import { render, staticRenderFns } from "./PointEvent.vue?vue&type=template&id=4bee9a81&scoped=true"
import script from "./PointEvent.vue?vue&type=script&lang=js"
export * from "./PointEvent.vue?vue&type=script&lang=js"
import style0 from "./PointEvent.vue?vue&type=style&index=0&id=4bee9a81&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bee9a81",
  null
  
)

export default component.exports